import { createFileRoute } from '@tanstack/react-router';
import { ActionRadarSection } from '@/features/radar/ActionRadarSection';
import { isMarket, type Market } from '@/lib/market/types';

export const Route = createFileRoute('/$market/market/action-radar')({
  component: MarketActionRadarRoute,
});

function MarketActionRadarRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';

  return (
    <div className="flex flex-col gap-4 pb-12">
      <ActionRadarSection market={market} />
    </div>
  );
}
